import { memo } from "react";
import Avatar from "components/mui5/Avatar";
import type { AvatarProps } from "components/mui5/Avatar";
import { useAthlete } from "hooks";
import useAthleteProfilePhotoURL from "hooks/useAthleteProfilePhotoURL";

interface AthleteAvatarProps extends Omit<AvatarProps, "src" | "alt"> {
  athleteId: string;
}

function AthleteAvatar(props: AthleteAvatarProps) {
  const { athleteId, size = "medium", ...rest } = props;

  const athlete = useAthlete(props.athleteId);
  const athleteAvatar = useAthleteProfilePhotoURL(athlete);

  return (
    <Avatar size={size} src={athleteAvatar.src} alt={athleteAvatar.alt} {...rest}>
      {athleteAvatar.initials}
    </Avatar>
  );
}

export default memo(AthleteAvatar);
